import { Text, Textarea, useToast, VStack } from '@chakra-ui/react';
import { IContactForm } from '@partiu/api/types';
import { useSendContactMutation } from '@partiu/api/user/hooks';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Button } from '../components/atoms/Button';
import { CellphoneInput, CPFInput, Input, SelectInput } from '../components/atoms/Input';
import { useProfile } from '../contexts/ProfileProvider';
import { useTheme } from '../contexts/ThemeProvider';
import { validateCPF } from '../utils';
import { masks } from '../masks';

export function ContactForm() {
  const toast = useToast();
  const { profile } = useProfile();
  const { name: agreementName } = useTheme();


  const [isSended, setIsSended] = React.useState(false)

  const {
    register,
    reset,
    handleSubmit,
    setValue,
  } = useForm<IContactForm>();

  const mutation = useSendContactMutation({
    onSuccess() {
      setIsSended(true)
      reset();
      toast({
        title: 'Mensagem Enviada!',
        description: 'Mensage enviada com sucesso. Logo um de nossos funcionários estará entrando em contato com você.',
        status: 'success',
      });
    },
    onError() {
      toast({
        title: 'Oops',
        description:
          'Não foi possível enviar sua mensagem. Verifique se os dados estão corretos, ou envie um email para suporte@partiu.com.br.',
        status: 'error',
      });
    },
  });

  const handleSubmitEmail = (data: IContactForm) => {
    if (!validateCPF(data.cpf)) {
      toast({
        status: 'error',
        title: 'Opss!',
        description: 'O CPF informado é inválido',
      });
      return;
    }

    if (masks.unmask(data.cellphone).length < 11) {
      toast({
        status: 'error',
        title: 'Opss!',
        description: 'O Celular informado é inválido',
      });
      return;
    }

    const payload: IContactForm = {
      name: data.name,
      email: data.email,
      subject: data.subject,
      message: data.message,
      cpf: data.cpf,
      cellphone: data.cellphone,
      agreement: agreementName,
      landing: 'Landing ' + agreementName,
      origin: 'landing',
    };

    mutation.mutate(payload);
  };

  useEffect(() => {
    setIsSended(false)

    if (!profile || !profile?.fullName) return;

    setValue('name', profile?.fullName || '');
    setValue('email', profile?.email || '');
    setValue('cpf', profile?.cpf || '');
    if (profile.telephone) setValue('cellphone', profile.telephone || '');

  }, [profile, setValue]);

  if(isSended) {
    return (
      <VStack spacing={8}>
        <Text fontSize={'18px'} textAlign={'center'}>
          Mensagem enviada com sucesso. Logo um de nossos funcionários estará entrando em contato com você.
        </Text>
      </VStack>
    )
  }

  return (
    <form onSubmit={handleSubmit(handleSubmitEmail)}>
      <VStack spacing={8}>
        <Text fontSize={'14px'}>
          Tem alguma dúvida? Preencha o formulário abaixo que entraremos em contato com você.
        </Text>
        <Input {...register('name', { required: true })} label="Nome" />
        <CellphoneInput {...register('cellphone', { required: true })} label="Celular" />
        <Input {...register('email', { required: true })} type="email" label="Email" />
        <CPFInput {...register('cpf')} value={profile?.cpf} label="CPF" />
        <SelectInput
          {...register('subject', { required: true })}
          label="Assunto"
          placeholder="Escolha um assunto"
          options={[
            { value: 'Dúvidas', label: 'Dúvidas' },
            { value: 'Reclamação', label: 'Reclamação' },
            { value: 'Exclusão', label: 'Exclusão' },
            { value: 'Outros', label: 'Outros' }
          ]}
        />
        <Textarea
          border="2px solid #d4d4d4"
          backgroundColor={'#f9f9f9'}
          {...register('message', { required: true })}
          placeholder="Digite seu comentário aqui"
        />
        <Button isLoading={mutation.isLoading} type="submit">Enviar</Button>
      </VStack>
    </form>
  );
}
